import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-public-footer-layout',
    standalone: true,
    imports: [
        RouterLink
    ],
    templateUrl: './public-footer-layout.component.html',
    styleUrl: './public-footer-layout.component.scss'
})
export class PublicFooterLayoutComponent {

    public newsletterEmail: string = '';

    public OnNewsletterEmailInput(event: Event): void {
        this.newsletterEmail = (event.target as HTMLInputElement).value;
    }

    public subscribeNewsletter(): void {
        const email: string = this.newsletterEmail.trim();

        if (!email) {
            return;
        }

        console.log('Newsletter:', email);
    }

    public scrollToTop(): void {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}